import React, { Component } from "react";
import moment from "moment";
import Alert from "react-s-alert";
import ToggleButton from 'react-toggle-button';
import _ from "lodash";
import './Site.css';
import { api, stringHelper, uiHelper, constant } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Link, Redirect } from "react-router-dom";
import {  } from "../components";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  ButtonGroup,
  Badge

} from 'reactstrap';
export default class ProductCoaResultDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      coaProductId: props.match && props.match.params && props.match.params.id
        ? props.match.params.id
        : null,
      productData: null
    }
    this.loadProductData = this.loadProductData.bind(this);
  }

  componentDidMount() {
    this.loadProductData();
  }

  loadProductData() {

  }

  render() {
    const {
      productData
    } = this.state;
    return (
      <div className="ml-4 mr-4">
        {productData &&
          <React.Fragment>
            <Row className="mb-2">
              <Col><h5>{productData.id < 0 ? "New" : ""} Product Results</h5></Col>
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" className="cbdmdSecondary buttonGroupSpacing" onClick={() => this.onCancel()} tag={Link}
                    to={{
                      pathname: "/coa",
                      push: true,
                    }}
                  >Back</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductCoaResultDetails.js